<template>
  <PlayerOption />
</template>

<script>
import PlayerOption from '@/components/user/PlayerOption.vue';

  export default {
    components: {
      PlayerOption,
    }
    
  }
</script>

<style lang="scss" scoped>

</style>